import { Col, Row } from 'antd';
import React from 'react';
import PropTypes from 'prop-types';
import SafetyAnomalyColumn from './SafetyAnomalyColumn';
import {
  DARK,
  SOS_STATUS_KEYS,
  SOS_STATUS_KEYS_TEXT,
} from '../../../../utilities/constants';
import { ReactComponent as InprogressSosTicketSvg } from '../../../../assets/icons/ongoing.svg';
import { ReactComponent as InprogressSosTicketWhiteSvg } from '../../../../assets/icons/ongoing-white.svg';
import { ReactComponent as OpenSosTicketSvg } from '../../../../assets/icons/new.svg';
import { ReactComponent as OpenSosTicketWhiteSvg } from '../../../../assets/icons/new-white.svg';
import { ReactComponent as ClosedSosTicketSvg } from '../../../../assets/icons/successful.svg';
import { ReactComponent as ClosedSosTicketWhiteSvg } from '../../../../assets/icons/successful-white.svg';
import SOActionModal from '../SOSLogs/SOActionModal';
import SOResolutionModel from '../SOSLogs/SOResolutionModel';
import { useTheme } from '../../../../context/ThemeContext';

const SOSColumns = ({
  sosData,
  isSoActionModalOpen,
  setIsSoActionModalOpen,
  isSoResolutionModelOpen,
  setIsSoResolutionModelOpen,
  clickedSosData,
  updateSOSList,
  loading,
}) => {
  const { theme } = useTheme();
  const openSosTicketIcon =
    theme === DARK ? OpenSosTicketSvg : OpenSosTicketWhiteSvg;
  const inprogressSosTicketIcon =
    theme === DARK ? InprogressSosTicketSvg : InprogressSosTicketWhiteSvg;
  const closedSosTicketIcon =
    theme === DARK ? ClosedSosTicketSvg : ClosedSosTicketWhiteSvg;

  return (
    <Row className="full-height safety-anomaly-row" gutter={[10, 10]}>
      <Col lg={8} xs={24} className="full-height overview-chart-spinner">
        <SafetyAnomalyColumn
          title={SOS_STATUS_KEYS_TEXT.PENDING}
          headerIcon={openSosTicketIcon}
          count={sosData?.[SOS_STATUS_KEYS.PENDING]?.length}
          dataList={sosData?.[SOS_STATUS_KEYS.PENDING]}
          loading={loading}
        />
      </Col>
      <Col lg={8} xs={24} className="full-height overview-chart-spinner">
        <SafetyAnomalyColumn
          title={SOS_STATUS_KEYS_TEXT.IN_PROGRESS}
          headerIcon={inprogressSosTicketIcon}
          count={sosData?.[SOS_STATUS_KEYS.IN_PROGRESS]?.length}
          dataList={sosData?.[SOS_STATUS_KEYS.IN_PROGRESS]}
          loading={loading}
        />
      </Col>
      <Col lg={8} xs={24} className="full-height overview-chart-spinner">
        <SafetyAnomalyColumn
          title={SOS_STATUS_KEYS_TEXT.RESOLVED}
          headerIcon={closedSosTicketIcon}
          count={sosData?.[SOS_STATUS_KEYS.RESOLVED]?.length}
          dataList={sosData?.[SOS_STATUS_KEYS.RESOLVED]}
          loading={loading}
        />
      </Col>
      <SOActionModal
        isModalOpen={isSoActionModalOpen}
        setIsModalOpen={setIsSoActionModalOpen}
        clickedSosData={clickedSosData}
        updateSOSList={updateSOSList}
      />
      <SOResolutionModel
        isModalOpen={isSoResolutionModelOpen}
        setIsModalOpen={setIsSoResolutionModelOpen}
        clickedSosData={clickedSosData}
        updateSOSList={updateSOSList}
      />
    </Row>
  );
};

SOSColumns.propTypes = {
  sosData: PropTypes.object,
  isSoActionModalOpen: PropTypes.bool.isRequired,
  setIsSoActionModalOpen: PropTypes.func.isRequired,
  isSoResolutionModelOpen: PropTypes.bool.isRequired,
  setIsSoResolutionModelOpen: PropTypes.func.isRequired,
  clickedSosData: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
  updateSOSList: PropTypes.func.isRequired,
  loading: PropTypes.bool.isRequired,
};

export default React.memo(SOSColumns);
